import React from 'react';
import { LocalString } from 'translate-react';

let Box = (props, context) => {
	let { ident } = props;
	let { store } = context;
	let state = store.getState();

	if ( !state.desktop.panelVisibility[props.ident] ) {
		return <div/>;
	}

	return (
		<div className={"accordion-box " + (props.open ? "open" : "closed") + " " + props.ident}>
			<div className="accordion-header">
				<h2><LocalString word={props.title} /></h2>
				{props.columns ? <props.columns {...props} /> : null}
				<div className="clear" />
			</div>
			<div className="accordion-content">
				{props.children}
			</div>
		</div>
	);
}

Box.contextTypes = { store: React.PropTypes.object };

Box.propTypes = {
	ident: React.PropTypes.string,
};

export default Box;



/** WEBPACK FOOTER **
 ** ../ibe/desktop/Box.js
 **/